import { Box, Button, IconButton, Tooltip } from "@mui/material"
import Datatable from "../../../components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import AddLabelForm from "./addlabelform";
import { deleteMasterData, disableAddModal, enableAddModal, fetchAlllabel } from "../../../slices/formbuildermaster";

const FormBuilderMasterData = () => {
    const dispatch = useDispatch()
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { isLoading, addModal } = useSelector((state) => state.bmrFormBuilderMaster);
    const [currentSearch, setCurrentSearch] = useState("");
    const [labelData, setLabelData] = useState({
        items: [],
        total_count: 0,
        page: 1,
        per_page: 10,
    })
    const searchDebounceRef = useRef(null);
    const columns = [
        {
            id: 'label',
            align: "center",
            name: 'Label',
            selector: row => row.label,
            sortable: true
        },
        {
            id: 'api_url',
            align: "center",
            name: 'API URL',
            selector: row => row.api_url,
            sortable: true
        },
        {
            id: 'depend_params',
            align: "center",
            name: 'Dependent Params', //@info this is for the dependent params of the label
            selector: row => Array.isArray(row.depend_params) ? row.depend_params.join(", ") : row.depend_params,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => {
                                setRowData(row)
                                handleAddModal()
                            }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title={row.is_used ? "Cannot delete: City is in use" : "Delete"} >
                    <span style={{
                        cursor: row.is_used ? 'not-allowed' : 'pointer',
                        display: 'inline-block',
                        pointerEvents: row.is_used ? 'all' : 'auto'
                    }}>
                        <IconButton
                            onClick={() => { if (!row.is_used) { setRowData(row); setOpen(true); } }}
                            sx={{
                                pointerEvents: row.is_used ? 'none' : 'auto',
                            }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];

    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeLabel = async () => {
        const { id } = rowData;
        await dispatch(deleteMasterData({ id }));
        setOpen(false);
        handleServerSideChange({
            page: labelData.page,
            per_page: labelData.per_page,
            search: currentSearch
        });
    };
    const handleServerSideChange = async (params) => {
        const searchValue = params.search || '';
        setCurrentSearch(searchValue);
        const trimmedSearch = searchValue.trim();

        try {
            setLoading(true);
            const result = await dispatch(fetchAlllabel({
                page: params.page,
                limit: params.per_page,
                search: trimmedSearch,
                sort_by: params.sort_by || 'id',
                order_by: params.sort_order || 'desc'
            })).unwrap();

            setLabelData({
                items: result?.data || [],
                total_count: result?.count || 0,
                page: result?.current_page || params.page,
                per_page: result?.limit || params.per_page
            });

        } catch (error) {
            console.error("Error fetching city list:", error);
        } finally {
            setLoading(false);
        }
    }
    const updateFilter = (params) => {
        const {
            page = 1,
            per_page = 10,
            search = '',
        } = params;
        const isSearchChange = search !== currentSearch;
        if (isSearchChange) {
            if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = setTimeout(() => {
                handleServerSideChange({
                    page: 1,
                    per_page,
                    search,
                    sort_by: params.sort_by,
                    sort_order: params.sort_order
                });
            }, 400);
        } else {
            handleServerSideChange({
                page,
                per_page,
                search,
                sort_by: params.sort_by,
                sort_order: params.sort_order
            });
        }
    };

    useEffect(() => {
        handleServerSideChange({ page: 1, per_page: 10, search: "" });
    }, []);
    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal
                open={addModal}
                onClose={handleCloseModal}
                title={rowData ? "Edit Label" : "Add New Label"}>
                <AddLabelForm editData={rowData} onSuccess={() => {
                    handleCloseModal();
                    handleServerSideChange({
                        page: labelData.page,
                        per_page: labelData.per_page,
                        search: currentSearch
                    });
                    setRowData(null);
                }} />
            </BsModal>
            <Datatable
                columns={columns}
                data={{
                    items: labelData.items,
                    total_count: labelData.total_count
                }}
                title="Formbuilder Master Data"
                searchPlaceholder="Search by label"
                loading={isLoading || loading}
                BtnComponent={<Button className="ml-2"
                    onClick={() => (handleAddModal(), setRowData(null))}
                >Add New Label</Button>}
                remote={true}
                onServerSideChange={updateFilter}
            />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeLabel}
            />
        </div>
    </div>
}
export default FormBuilderMasterData